/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import ReactPlayer from 'react-player'
import { Waypoint } from 'react-waypoint'
import renderHTML from 'react-render-html'
import './styles.scss'

export class VideoPlayer extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isInView: false,
      dimensions: { width: -1, height: -1 }
    }
    this.isMobile = window.innerWidth < 600
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    this.onImgLoad = this.onImgLoad.bind(this)
    this.playVideo = this.playVideo.bind(this)
  }

  onImgLoad({ target: img }) {
    this.setState({
      dimensions: { height: img.offsetHeight, width: img.offsetWidth }
    })
  }

  playVideo() {
    // console.log('playVideo')

    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `play-video: ` + this.props.mp4
    })

    this.setState({ isInView: true })
  }

  handleEnded = () => {
    // console.log('onEnded')
  }

  ref = player => {
    this.player = player
  }

  render() {
    return (
      <div className='videoplayer'>
        {/* see here https://github.com/CookPete/react-player/blob/master/src/demo/App.js */}
        <div className='wrapper'>
          <ReactPlayer
            ref={this.ref}
            className='react-player'
            width='100%'
            height={
              this.state.dimensions.height > 0
                ? this.state.dimensions.height + 'px'
                : '100%'
            }
            url={[
              {
                src: this.state.isInView ? this.props.mp4 : null,
                type: 'video/mp4'
              }
            ]}
            playing={this.state.isInView} // {this.props.autoPlay ? true : false}
            playsinline // {!this.isIOS}
            controls
            muted
            loop
            onEnded={this.handleEnded}
            /*
          poster={this.props.poster}
          pip={pip}
          playing={playing}
          controls={controls}
          light={light}
          loop={loop}
          playbackRate={playbackRate}
          volume={volume}
          muted={muted}
          onReady={() => console.log('onReady')}
          onStart={() => console.log('onStart')}
          
          onEnablePIP={this.handleEnablePIP}
          onDisablePIP={this.handleDisablePIP}
          onPause={this.handlePause}
          onBuffer={() => console.log('onBuffer')}
          onSeek={e => console.log('onSeek', e)}
          onEnded={this.handleEnded}
          onError={e => console.log('onError', e)}
          onProgress={this.handleProgress}
          onDuration={this.handleDuration}
          */
          />
          {this.props.posterImage !== null && !this.state.isInView && (
            <div className='poster' onClick={this.playVideo}>
              <img
                className='ui image fluid'
                src={this.props.posterImage}
                onLoad={this.onImgLoad}
              />
            </div>
          )}
          <Waypoint
            bottomOffset='-50%'
            onEnter={event => {
              // console.log('isInView: ', this.props.mp4)
              this.setState({ isInView: true })
            }}
            onLeave={event => {
              // console.log('NOT isInView: ', this.props.mp4)
              this.setState({ isInView: false })
            }}
          />
        </div>
        {this.props.caption !== null && (
          <figcaption>{renderHTML(this.props.caption)}</figcaption>
        )}
      </div>
    )
  }
}
